import * as RadioGroup from '@radix-ui/react-radio-group';
import PropTypes from 'prop-types';
import './RadioButtonRatesGroup.css';
import { useDispatch, useSelector } from 'react-redux';
import { setTempRate } from 'features/cart/cartSlice';
import { openModal } from 'features/modalSlice';

const RadioButtonRatesGroup = ({
    setSelectedRate,
    defaultValue = '',
    rates = {},
    defaultRate = {},
    currencySymbol = '',
    outerClass = '',
    wrapperClass = '',
    rightLabelClass = '',
}) => {
    const hasCart = useSelector(
        (state) => state.miniBookingWidget?.data?.hasCart
    );
    const isAddingRate = useSelector((state) => state.cart?.isAddingRate);

    const cartItems = useSelector((state) => state.cart?.cartItems);
    const dispatch = useDispatch();
    const onValueChange = (rateIndex) => {
        if (hasCart) {
            if (isAddingRate) {
                return;
            }
            if (cartItems.some((item) => rates[rateIndex].roomTypeID)) {
                if (
                    !cartItems.some(
                        (item) =>
                            item.rateID === rates[rateIndex].rateID &&
                            rates[rateIndex].roomTypeID
                    )
                ) {
                    dispatch(
                        setTempRate({
                            tempRate: rates[rateIndex].rateID,
                            roomTypeID: rates[rateIndex].roomTypeID,
                        })
                    );
                    dispatch(
                        openModal({
                            modalId: 'AreYouSureModal',
                        })
                    );
                }
            } else {
                setSelectedRate(rates[rateIndex]);
            }
        } else {
            setSelectedRate(rates[rateIndex]);
        }
    };

    return (
        <form>
            <RadioGroup.Root
                className="ab-RadioGroupRoot"
                defaultValue={0}
                aria-label="View density"
                onValueChange={onValueChange}
            >
                {/* Do not show the first rate as it is the one that is displayed by default */}
                {rates.map((rate, index) => {
                    let rightLabelText = `${rate.pricing.price} ${currencySymbol}`;
                    if (rate.pricing.memberPrice) {
                        rightLabelText = `${rate.pricing.memberPrice} ${currencySymbol}`;
                    }
                    const isAvailable = rate?.availableRooms?.length > 0;
                    // const priceDiff =
                    //     +rate.pricing.price - +defaultRate.pricing.price;
                    // if (rate.pricing.price && defaultRate.pricing.price) {
                    //     rightLabelText = `+ ${priceDiff} ${currencySymbol}`;
                    // }

                    const buttonID = 'r' + index;
                    return (
                        <div
                            className={`ab-room-extra-offer ${
                                !isAvailable ? 'not-available' : ''
                            }`}
                            key={index}
                        >
                            <div className={outerClass}>
                                <label className={wrapperClass}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingRight: '5px',
                                        }}
                                    >
                                        <RadioGroup.Item
                                            className="ab-RadioGroupItem"
                                            value={index}
                                            id={buttonID}
                                        >
                                            <RadioGroup.Indicator className="ab-RadioGroupIndicator" />
                                        </RadioGroup.Item>
                                    </div>
                                    {rate.rate}
                                </label>
                                <div className={rightLabelClass}>
                                    {rightLabelText}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </RadioGroup.Root>
        </form>
    );
};

RadioButtonRatesGroup.propTypes = {
    setSelectedRate: PropTypes.func,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    currencySymbol: PropTypes.string,
    outerClass: PropTypes.string,
    wrapperClass: PropTypes.string,
    rightLabelClass: PropTypes.string,
    rates: PropTypes.object,
    defaultRate: PropTypes.object,
};

export default RadioButtonRatesGroup;
